import { styled } from '@mui/material';

export const CommentsList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;
